"use client";

import type { FC } from "react";

import clsx from "clsx";

import { Button } from "@ui/components/core/Button";
import IconChevronLeft from "@ui/central-icons/icons/IconChevronLeft";
import IconChevronRight from "@ui/central-icons/icons/IconChevronRight";

export interface BookNavigationArrowsProps {
  onPrev?: () => void;
  onNext?: () => void;
  variant?: "secondary-inverse" | "elevated";
  size?: "default" | "small" | "responsive";
  className?: string;
}

const buttonSizeMap = {
  default: "pill",
  small: "pill-sm",
  responsive: "pill-responsive",
} as const;

export const BookNavigationArrows: FC<BookNavigationArrowsProps> = ({
  onPrev,
  onNext,
  variant = "secondary-inverse",
  size = "default",
  className,
}) => {
  // Don't render if neither navigation callback is provided
  if (!onPrev && !onNext) {
    return null;
  }

  const buttonSize = buttonSizeMap[size];

  return (
    <div className={clsx("tw-flex", size === "default" ? "tw-gap-3" : "tw-gap-2", className)}>
      <Button variant={variant} size={buttonSize} onClick={onPrev} aria-label='Previous book'>
        <IconChevronLeft
          className={clsx(size === "default" ? "tw-size-4" : "tw-size-3", size === "responsive" && "md:tw-size-4")}
        />
      </Button>
      <Button variant={variant} size={buttonSize} onClick={onNext} aria-label='Next book'>
        <IconChevronRight
          className={clsx(size === "default" ? "tw-size-4" : "tw-size-3", size === "responsive" && "md:tw-size-4")}
        />
      </Button>
    </div>
  );
};
